import { useMainStore } from '@/stores/main'

// 公告顯示的單一入口：網址觸發登入／註冊彈窗時延後、彈窗關閉後補跳
// 規格：spec/JT-1784716920_url-modal-trigger-announcement-deferral.md §5.4
//
// 「延後」只搬動開窗這個動作，不碰篩選也不寫任何 storage —— 傳入的 list 已是既有篩選
// （isBroadcast／displayMode／未過期／未讀／非 display_off）之後的結果，因此公告不會
// 被提早標記已讀，補跳的則數與「未帶參數直接進大廳」完全相同
//
// 三個函式都是「呼叫當下讀一次狀態」的命令式動作，不需要 ref，故直接讀 store 屬性而非
// storeToRefs()——後者每次呼叫都會產生一組 ObjectRefImpl，而本檔在 SSR 期間會被
// default.vue 與 guest.vue 各呼叫一次（規範：storeToRefs 只能放在單例內部）
export const useAnnouncementQueue = () => {
  const mainStore = useMainStore()
  const { setSystemModal, setSystemModalParams, setDeferredAnnouncement, setUrlModalPending } = mainStore

  const openAnnouncement = (list) => {
    setSystemModalParams({ list })
    setSystemModal('ModalAnnouncement')
  }

  const presentAnnouncement = (list) => {
    if (!list?.length) return
    if (mainStore.getUrlModalPending) {
      setDeferredAnnouncement({ list })
      return
    }
    openAnnouncement(list)
  }

  const clearDeferredAnnouncement = () => {
    setDeferredAnnouncement(null)
    setUrlModalPending(null)
  }

  const flushDeferredAnnouncement = () => {
    const pending = mainStore.getDeferredAnnouncement
    clearDeferredAnnouncement()
    if (!pending?.list?.length) return
    openAnnouncement(pending.list)
  }

  return {
    presentAnnouncement,
    flushDeferredAnnouncement,
    clearDeferredAnnouncement,
  }
}
